import { Controller } from '@hotwired/stimulus'

// Toggles [hidden] on an element elsewhere in the DOM by id — not a
// Stimulus target since the toggled element usually isn't a descendant
// (e.g. a sidebar panel toggled from a button in a separate toolbar).
export default class extends Controller {
  static values = { targetId: String }

  toggle() {
    const panel = document.getElementById(this.targetIdValue)
    if (panel) panel.hidden = !panel.hidden
  }
}
